/* Delivery slot logic for the cart page. No jQuery.
   Reads every rule from data attributes set by the section settings, so nothing
   here needs editing when a holiday or a zone changes. */
(function () {
  function init() {
    var root = document.getElementById('dx-delivery');
    if (!root || root.dataset.dxReady) return;
    root.dataset.dxReady = '1';

    var cutoffHour = parseInt(root.dataset.cutoffHour, 10); if (isNaN(cutoffHour)) cutoffHour = 22;
    var leadDays = parseInt(root.dataset.leadDays, 10); if (isNaN(leadDays)) leadDays = 1;
    var maxDays = parseInt(root.dataset.maxDays, 10); if (isNaN(maxDays)) maxDays = 30;
    var blocked = (root.dataset.blockedWeekdays || '').split(',').map(function (s) { return parseInt(s, 10); }).filter(function (n) { return !isNaN(n); });
    var holidays = (root.dataset.holidays || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean); // dd/mm/yyyy
    var zoneRules = [];
    try { zoneRules = JSON.parse(root.dataset.zoneRules || '[]'); } catch (e) { zoneRules = []; }

    // Refresh's <cart-items> treats ANY change event inside the cart form as a
    // quantity update (cart.js onChange -> updateQuantity with no line index), which
    // fires a broken /cart/change.js, shows a cart error, and re-renders the section.
    // Our own listeners sit on the inputs themselves, so stopping the bubble here is safe.
    root.addEventListener('change', function (e) { e.stopPropagation(); });

    var elFulfil = root.querySelectorAll('input[name="attributes[Fulfilment]"]');
    var elPostalRow = document.getElementById('dxd-postal-row');
    var elPostal = document.getElementById('dxd-postal');
    var elZone = document.getElementById('dxd-zone');
    var elZoneAttr = document.getElementById('dxd-zone-attr');
    var elDate = document.getElementById('dxd-date');
    var elDateAttr = document.getElementById('dxd-date-attr');
    var elQuick = document.getElementById('dxd-quick');
    var elMsg = document.getElementById('dxd-msg');
    var elHelp = document.getElementById('dxd-help');
    if (!elPostal || !elZone || !elZoneAttr || !elDate || !elDateAttr || !elQuick || !elMsg) return;
    var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    // "now" in Singapore regardless of the customer's device clock
    function sgNow() {
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Singapore', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hour12: false }).formatToParts(new Date());
      var o = {}; parts.forEach(function (p) { o[p.type] = p.value; });
      return { y: +o.year, m: +o.month, d: +o.day, h: +o.hour % 24 };
    }
    function mkDate(y, m, d) { return new Date(Date.UTC(y, m - 1, d)); }
    function addDays(dt, n) { return new Date(dt.getTime() + n * 86400000); }
    function iso(dt) { return dt.toISOString().slice(0, 10); }
    function dmy(dt) { var d = dt.getUTCDate(), m = dt.getUTCMonth() + 1; return (d < 10 ? '0' : '') + d + '/' + (m < 10 ? '0' : '') + m + '/' + dt.getUTCFullYear(); }
    function fromDmy(s) { var m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(s || ''); return m ? mkDate(+m[3], +m[2], +m[1]) : null; }
    function fromIso(s) { var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s || ''); return m ? mkDate(+m[1], +m[2], +m[3]) : null; }
    function label(dt) { return DAYS[dt.getUTCDay()].slice(0, 3) + ' ' + dt.getUTCDate() + ' ' + ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][dt.getUTCMonth()]; }

    function isCollection() { var c = root.querySelector('input[name="attributes[Fulfilment]"]:checked'); return c && c.value === 'Self collection'; }
    function zoneFor(postal) {
      if (!/^\d{6}$/.test(postal)) return null;
      var district = postal.slice(0, 2);
      for (var i = 0; i < zoneRules.length; i++) { if ((zoneRules[i].districts || []).indexOf(district) !== -1) return zoneRules[i]; }
      return { zone: 'Unmatched', days: null };
    }
    function earliest() {
      var n = sgNow(), start = addDays(mkDate(n.y, n.m, n.d), leadDays);
      if (n.h >= cutoffHour) start = addDays(start, 1);
      return start;
    }
    function allowed(dt, rule) {
      var wd = dt.getUTCDay();
      if (blocked.indexOf(wd) !== -1) return false;
      if (holidays.indexOf(dmy(dt)) !== -1) return false;
      if (!isCollection() && rule && rule.days && rule.days.indexOf(wd) === -1) return false;
      return true;
    }
    // Name the days, never "any day": a run of three or more reads "Wednesday to Sunday",
    // otherwise "Wednesday, Friday and Sunday". Monday first, so Sunday sorts last.
    function dayList(days) {
      var o = days.slice().map(function (d) { return d || 7; }).sort(function (a, b) { return a - b; });
      var nm = function (d) { return DAYS[d % 7]; };
      var run = o.length >= 3 && o.every(function (d, i) { return i === 0 || d === o[i - 1] + 1; });
      if (run) return nm(o[0]) + ' to ' + nm(o[o.length - 1]);
      if (o.length === 1) return nm(o[0]);
      return o.slice(0, -1).map(nm).join(', ') + ' and ' + nm(o[o.length - 1]);
    }
    function currentRule() { return isCollection() ? null : zoneFor((elPostal.value || '').trim()); }

    function renderZone() {
      var rule = currentRule();
      elPostalRow.style.display = isCollection() ? 'none' : '';
      if (isCollection()) { elZone.textContent = ''; elZoneAttr.value = 'Self collection'; return; }
      if (!rule) { elZone.textContent = ''; elZoneAttr.value = ''; return; }
      if (!rule.days) { elZone.textContent = 'We will confirm the delivery day for this postal code on WhatsApp.'; elZoneAttr.value = 'Unmatched'; return; }
      elZone.textContent = 'Your zone: ' + rule.zone + '. Delivery days: ' + dayList(rule.days) + '.' + (rule.note ? ' ' + rule.note : '');
      elZoneAttr.value = rule.zone;
    }
    function renderQuick() {
      var rule = currentRule(), start = earliest(), out = [], dt = start;
      for (var i = 0; i < maxDays && out.length < 6; i++) { if (allowed(dt, rule)) out.push(dt); dt = addDays(dt, 1); }
      var chosen = elDate.value, key = out.map(iso).join(',');
      // Same dates as last time: only update which chip is pressed. Rebuilding here removed the chip
      // a shopper was tapping (the postal field's change event fires on that tap), so the first tap was lost.
      if (elQuick.dataset.key === key && elQuick.children.length === out.length) {
        Array.prototype.forEach.call(elQuick.children, function (b, i) { b.setAttribute('aria-pressed', iso(out[i]) === chosen ? 'true' : 'false'); });
      } else {
        elQuick.innerHTML = '';
        elQuick.dataset.key = key;
        out.forEach(function (d) {
          var b = document.createElement('button'); b.type = 'button'; b.textContent = label(d);
          b.setAttribute('aria-pressed', iso(d) === chosen ? 'true' : 'false');
          b.addEventListener('click', function () { elDate.value = iso(d); onDate(); persist(); });
          elQuick.appendChild(b);
        });
      }
      elDate.min = iso(start); elDate.max = iso(addDays(start, maxDays));
      var n = sgNow();
      elHelp.textContent = 'Order by ' + (cutoffHour > 12 ? (cutoffHour - 12) + 'pm' : cutoffHour + 'am') + ' for the next delivery day.' + (n.h >= cutoffHour ? ' It is past the cutoff, so the earliest day is ' + label(start) + '.' : '');
    }
    function validate(show) {
      var dt = fromIso(elDate.value), rule = currentRule(), msg = '';
      if (!isCollection() && !/^\d{6}$/.test((elPostal.value || '').trim())) msg = 'Enter your 6 digit postal code so we can show your delivery days.';
      else if (!dt) msg = 'Pick a delivery date.';
      else if (dt < earliest()) msg = 'That date is too soon. The earliest we can deliver is ' + label(earliest()) + '.';
      else if (dt > addDays(earliest(), maxDays)) msg = 'Please pick a date within the next ' + maxDays + ' days.';
      else if (!allowed(dt, rule)) msg = (isCollection() ? 'The stall is closed that day.' : 'We do not deliver to your area on a ' + DAYS[dt.getUTCDay()] + '.') + ' Pick one of the dates above.';
      if (show) { elMsg.textContent = msg; root.classList.toggle('dxd--invalid', !!msg); }
      return !msg;
    }
    function onDate() {
      renderQuick();
      // persist the kitchen-facing dd/mm/yyyy attribute only once the date is valid
      var ok = validate(true), dt = fromIso(elDate.value);
      elDateAttr.value = ok && dt ? dmy(dt) : '';
    }

    // restore a saved dd/mm/yyyy date into the native input
    var saved = fromDmy(root.dataset.savedDate || elDateAttr.value);
    if (saved) elDate.value = iso(saved);

    // persist choices to the cart as they are made, so the section re-render that
    // follows a quantity change restores them from cart.attributes instead of wiping them
    var persistTimer = null;
    function persist() {
      clearTimeout(persistTimer);
      persistTimer = setTimeout(function () {
        var fulfil = root.querySelector('input[name="attributes[Fulfilment]"]:checked');
        var box = document.getElementById('boxtype'), box2 = document.getElementById('boxtype2');
        var attrs = {
          'Fulfilment': fulfil ? fulfil.value : 'Delivery',
          'Postal code': isCollection() ? '' : (elPostal.value || '').trim(),
          'Delivery zone': elZoneAttr.value || '',
          'date': elDateAttr.value || '',
          'boxtype': box ? box.value : '',
          'boxtype2': box2 ? box2.value : '',
          'Referred by': (function () { var r = document.getElementById('dxd-referral'); return r ? r.value.trim() : ''; })()
        };
        try { document.dispatchEvent(new CustomEvent('dx:slot', { detail: attrs })); } catch (e) {}
        fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ attributes: attrs }) }).catch(function () {});
      }, 400);
    }

    function onPostal() { renderZone(); if (elDate.value) onDate(); else renderQuick(); persist(); }
    elPostal.addEventListener('input', onPostal);
    // autofill and back/forward restores can fill the field without an input event
    elPostal.addEventListener('change', onPostal);
    window.addEventListener('pageshow', function () { renderZone(); if (elDate.value) onDate(); });
    Array.prototype.forEach.call(elFulfil, function (r) { r.addEventListener('change', function () { renderZone(); if (elDate.value) onDate(); else renderQuick(); persist(); }); });
    elDate.addEventListener('change', function () { onDate(); persist(); });
    ['boxtype', 'boxtype2'].forEach(function (i) { var el = document.getElementById(i); if (el) el.addEventListener('change', persist); });
    var elRef = document.getElementById('dxd-referral');
    if (elRef) elRef.addEventListener('change', persist);

    // the gate: nothing leaves the cart form without a valid slot. The visible fields are what get
    // validated, so the hidden attributes the order carries are rebuilt from them right here; on
    // 4 Oct an autofilled postal code left the hidden date and zone empty while the gate passed.
    function syncHidden() {
      renderZone();
      var dt = fromIso(elDate.value);
      elDateAttr.value = dt && validate(false) ? dmy(dt) : '';
    }
    var form = root.closest('form');
    if (form) {
      form.addEventListener('submit', function (e) {
        var isCheckout = e.submitter && e.submitter.name === 'checkout';
        if (!isCheckout) return;
        syncHidden();
        if (!validate(true) || !elDateAttr.value || !elZoneAttr.value) { e.preventDefault(); root.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      });
      // The checkout button sits outside the form (form="cart"), so a listener on form children never
      // saw it and only the browser's own "fill in this field" bubble stopped an empty date. The
      // document-level guard below calls this so the shopper gets our message and the scroll.
      // re-render hook for the document level safety net below
      window.__dxRender = function () { renderZone(); if (elDate.value) onDate(); else renderQuick(); persist(); };
      window.__dxCheckoutGate = function () { syncHidden(); var ok = validate(true) && !!elDateAttr.value && !!elZoneAttr.value; if (!ok) root.scrollIntoView({ behavior: 'smooth', block: 'center' }); return ok; };
      window.__dxCartForm = form;
    }

    renderZone(); renderQuick(); if (elDate.value) validate(false);
  }
  // Safety net (10 Oct 2026): in 2 of about 15 test runs a Self collection tap left the delivery box un-set-up
  // (no date chips, postal still showing). Any change inside the box now makes sure the box is set up and re-renders it.
  if (!window.__dxChangeNet) {
    window.__dxChangeNet = true;
    ['change', 'input'].forEach(function (type) {
      document.addEventListener(type, function (e) {
        var t = e.target; if (!t || !t.closest) return;
        var root = t.closest('#dx-delivery'); if (!root) return;
        if (!/^attributes\[(Fulfilment|Postal code)\]$/.test(t.name || '') && t.id !== 'dxd-date') return;
        if (!root.dataset.dxReady) init();
        setTimeout(function () { if (window.__dxRender) window.__dxRender(); }, 0);
      }, true);
    });
  }
  if (!window.__dxCheckoutGuard) {
    window.__dxCheckoutGuard = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('button[name="checkout"]');
      if (!btn || !window.__dxCheckoutGate || btn.form !== window.__dxCartForm || !document.getElementById('dx-delivery')) return;
      if (!window.__dxCheckoutGate()) e.preventDefault();
    }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // the cart page re-renders its section on quantity changes; re-init when that happens
  document.addEventListener('cart:refresh', init);
  new MutationObserver(function () { init(); }).observe(document.documentElement, { childList: true, subtree: true });
})();
